import React from "react";
import {
  Dialog,
  DialogContent,
  DialogActions,
  Button,
  Box,
  Typography,
  Stack
} from "@mui/material";
import BuildIcon from "@mui/icons-material/Build";

const NoTradeModal = ({ open = false, onClose = () => {}, onAddTrade = () => {} }) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: "12px",
          boxShadow: "0 4px 20px rgba(0, 0, 0, 0.15)"
        }
      }}>
      <DialogContent sx={{ textAlign: "center", pt: 4, pb: 3 }}>
        <Stack alignItems="center" spacing={2}>
          {/* Icon Container */}
          <Box
            sx={{
              width: "80px",
              height: "80px",
              borderRadius: "50%",
              backgroundColor: "#e8f4f8",
              display: "flex",
              alignItems: "center",
              justifyContent: "center"
            }}>
            <BuildIcon
              sx={{
                fontSize: "48px",
                color: "#1976d2"
              }}
            />
          </Box>

          {/* Title */}
          <Typography variant="h5" sx={{ fontWeight: 600, color: "#1a1a1a" }}>
            No Trade Set
          </Typography>

          {/* Description */}
          <Typography
            variant="body2"
            sx={{
              color: "#666",
              lineHeight: "1.6",
              px: 1
            }}>
            You have not added a trade to your profile. Would you like to add one now? This will
            help you find relevant job postings.
          </Typography>
        </Stack>
      </DialogContent>

      {/* Action Buttons */}
      <DialogActions
        sx={{
          justifyContent: "center",
          gap: 1.5,
          pb: 3,
          px: 3
        }}>
        <Button
          onClick={onClose}
          variant="outlined"
          size="large"
          sx={{
            flex: 1,
            textTransform: "none",
            fontSize: "16px",
            fontWeight: 500,
            borderRadius: "8px",
            color: "#1976d2",
            borderColor: "#1976d2",
            "&:hover": {
              backgroundColor: "rgba(25, 118, 210, 0.04)"
            }
          }}>
          No, Continue
        </Button>
        <Button
          onClick={onAddTrade}
          variant="contained"
          size="large"
          sx={{
            flex: 1,
            textTransform: "none",
            fontSize: "16px",
            fontWeight: 500,
            borderRadius: "8px",
            backgroundColor: "#1e3a5f",
            "&:hover": {
              backgroundColor: "#152840"
            }
          }}>
          Add Trade
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default NoTradeModal;
